import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "close.small" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon",
    d: "M15.0012 14.9807L10.0064 10.0032M10.0064 10.0032L5.01805 14.9877M10.0064 10.0032L5.00021 5.0009M10.0064 10.0032L15.0123 4.9877",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }